<template>
  <OLink
    v-if="author"
    :href="author.url"
    v-bind="{ target: '_blank' }"
    class="bg-[#181819] rounded-2xl px-4 py-3 text-white"
    :class="{
      'flex flex-col sm:flex-row w-full sm:justify-between items-start sm:items-center': isKunye,
      'inline-flex items-center': !isKunye,
    }"
  >
    <div class="flex items-center gap-4">
      <div class="w-12 h-12 rounded-full overflow-hidden">
        <OAvatar :src="author.image" :alt="author.name" class="w-11 h-11" :rounded="true" />
      </div>
      <div class="flex flex-col">
        <div class="text-14 font-bold line-clamp-1">{{ author.name || author.username }}</div>
        <div class="text-12 text-primary-200 line-clamp-1">{{ author.title }}</div>
      </div>
    </div>
    <div
      v-if="isKunye"
      class="
        inline-flex
        items-center
        justify-center
        sm:justify-start
        border border-white
        rounded-full
        px-4
        py-2
        gap-3
        text-md
        font-medium
        text-white
        w-full
        sm:w-auto
        mt-4
        sm:mt-0
      "
    >
      Tüm İçerikleri
      <OIcon icon="right-white" />
    </div>
  </OLink>
</template>

<script>
import { defineComponent, computed } from '@nuxtjs/composition-api';
import { getImageUrl } from '~/modules/common/utils/imageUtils';
import { getProfileUrl } from '~/modules/common/utils/routingUtils';
import { OAvatar, OLink, OIcon } from '~/modules/common/components/ui';
export default defineComponent({
  components: {
    OAvatar,
    OLink,
    OIcon,
  },
  props: {
    authors: {
      type: Array,
      required: true,
    },
    isKunye: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const author = computed(() => {
      const author = props.authors[0];
      if (!author) return null;
      return {
        image: getImageUrl(author.avatar, { width: 50 }),
        url: getProfileUrl({ user: author }),
        name: author.name,
        username: author.username,
        title: author.title,
      };
    });
    return { author };
  },
});
</script>
